<!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
<script setup>
// Card "Perfil de busca" do "Histórico de cliente" (orçamento, intenção,
// pagamento, regiões e preferências). Extraído de HistoricoCliente.vue 1:1.
import { computed } from 'vue';
import LaisCard from 'dashboard/components-next/LaisCard.vue';
import LaisInfoRow from 'dashboard/components-next/LaisInfoRow.vue';
import { compactList, formatCurrency } from '../utils/leadHistoryPresenter';

const props = defineProps({
  profile: { type: Object, default: null },
});

const buyerProfileBudget = computed(() => {
  const profile = props.profile || {};
  const min = formatCurrency(profile.budget_min || profile.faixa_preco_min);
  const max = formatCurrency(profile.budget_max || profile.faixa_preco_max);
  if (min && max) return `${min} a ${max}`;
  return min || max || 'Não informado';
});

const buyerIntentLabel = computed(() => {
  const profile = props.profile || {};
  if (profile.intent === 'investor' || profile.investidor === true) {
    return 'Investidor';
  }
  if (profile.intent === 'home') return 'Moradia própria';
  return 'Não classificado';
});

const profileRegions = computed(() =>
  compactList(props.profile?.regions || props.profile?.regioes)
);

const profileTypes = computed(() =>
  compactList(
    props.profile?.property_types || props.profile?.tipos || props.profile?.tipo
  )
);

const profileBedrooms = computed(() =>
  compactList(props.profile?.bedrooms || props.profile?.quartos)
);
</script>

<template>
  <!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
  <LaisCard title="Perfil de busca">
    <div class="flex flex-col">
      <LaisInfoRow icon="i-lucide-badge-dollar-sign" label="Orçamento">
        {{ buyerProfileBudget }}
      </LaisInfoRow>
      <LaisInfoRow icon="i-lucide-user-round-check" label="Intenção">
        {{ buyerIntentLabel }}
      </LaisInfoRow>
      <LaisInfoRow
        icon="i-lucide-credit-card"
        label="Pagamento"
        :value="
          profile?.payment_kind || profile?.forma_pagamento || 'Não informado'
        "
      />
    </div>
    <div class="mt-4 grid gap-3">
      <div v-if="profileRegions.length">
        <p class="text-[11px] font-semibold uppercase text-lais-text-muted">
          Regiões
        </p>
        <div class="mt-2 flex flex-wrap gap-2">
          <span
            v-for="region in profileRegions"
            :key="region"
            class="rounded-full bg-[#f0e8fa] px-2.5 py-1 text-[12px] font-semibold text-lais-primary"
          >
            {{ region }}
          </span>
        </div>
      </div>
      <div v-if="profileTypes.length || profileBedrooms.length">
        <p class="text-[11px] font-semibold uppercase text-lais-text-muted">
          Preferências
        </p>
        <div class="mt-2 flex flex-wrap gap-2">
          <span
            v-for="type in profileTypes"
            :key="`type-${type}`"
            class="rounded-full bg-[#f5f5f5] px-2.5 py-1 text-[12px] font-semibold text-lais-text-body"
          >
            {{ type }}
          </span>
          <span
            v-for="bedroom in profileBedrooms"
            :key="`bedroom-${bedroom}`"
            class="rounded-full bg-[#fff7ed] px-2.5 py-1 text-[12px] font-semibold text-[#c2410c]"
          >
            {{ bedroom }} quartos
          </span>
        </div>
      </div>
    </div>
  </LaisCard>
</template>
